package one.healthium.insights.data

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flow
import one.healthium.insights.data.mapper.ContentScreenMapper
import one.healthium.insights.data.sources.network.ContentApiClient
import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.insights.domain.workouts.WorkoutsRepository

internal class AppWorkoutsRepository(
    private val apiClient: ContentApiClient,
    private val contentScreenMapper: ContentScreenMapper,
    private val localeProvider: one.healthium.locale.LocaleProvider,
) : WorkoutsRepository {

    private var screenCache: ContentScreenModel? = null

    override fun getScreen(): Flow<ContentScreenModel> {
        return flow {
            val cachedValue = screenCache
            if (cachedValue != null) {
                emit(cachedValue)
            }
            val locale = localeProvider.getLocale()
            val contentScreenDto = apiClient.getWorkoutsScreen(locale)
            val contentScreenModel = contentScreenMapper.dtoToModel(contentScreenDto)
            screenCache = contentScreenModel
            emit(contentScreenModel)
        }.distinctUntilChanged()
    }
}